import { Component, OnInit } from '@angular/core';
import { RequestService } from '../services/request.service';

@Component({
  selector: 'app-activatedescription',
  templateUrl: './activatedescription.component.html',
  styleUrls: ['./activatedescription.component.css']
})
export class ActivatedescriptionComponent implements OnInit {
  message = '';
  requests: Request[] = [];
  comment = '';

  constructor(
    private requestService: RequestService,
  ) { }

  ngOnInit() {
  }
  showRequest(email){
    this.requestService.getRequestsForEmail(email).valueChanges().subscribe(
      (data: Request[]) => {
        this.requests = data;
        if (this.requests.length == 0) {
          this.message = 'El usuario, aún no tiene solicitudes.';
        } else {
          this.message = '';
        }
      }, (error) => {
        console.log(error);
      });
    
  }
  setDeleted(request) {
    const hid = Date.now();
    const status = 'eliminado';
    const history ={
      hid: hid.toString(),
      comment: this.comment,
      status: status
    }
    this.requestService.setRequestStatus(request, status).then(
      () => {
    }).catch(
      (error) => {
        console.log(error);
      });
    this.requestService.setRequestHistory(request, history).then(
      () => {
        alert('Proyecto eliminado.');
    }).catch(
      (error) => { 
      console.log(error)
    });
  }
  setSuspended(request) {
    const hid = Date.now();
    const status = 'suspendido';
    const history ={
      hid: hid.toString(),
      comment: this.comment,
      status: status
    }
    this.requestService.setRequestStatus(request, status).then(
      () => {
    }).catch(
      (error) => {
        console.log(error);
      });
    this.requestService.setRequestHistory(request, history).then(
      () => {
        alert('Proyecto suspendido.');
    }).catch(
      (error) => { 
      console.log(error)
    });
  }

}
